import { portalAction, portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { Box, Typography } from "@mui/material";
import { PcsEventInstanceDto } from "../../../app/models/events/pcsEventInstanceDto";

interface Props {
    event: PcsEventInstanceDto;
    onClick?: () => void;
}

function getDateParts(value: PcsEventInstanceDto['startDate']) {
    const date = value ? new Date(value) : null;
    if (!date || Number.isNaN(date.getTime())) return { day: '--', month: '' };
    return { day: date.getDate().toString().padStart(2, '0'), month: date.toLocaleDateString('en-GB', { month: 'short' }).toUpperCase() };
}

export default function EventCard({ event, onClick }: Props) {
    const { day, month } = getDateParts(event.startDate);
    const date = event.startDate ? new Date(event.startDate) : null;
    const dateTime = date && !Number.isNaN(date.getTime()) ? date.toISOString() : undefined;

    return (
        <Box
            component="button"
            type="button"
            disabled={!onClick}
            onClick={portalAction(portalScreenContext('EventCard'), 'EventCard.onClick.onClick', onClick)}
            aria-label={onClick ? `View details for ${event.description || 'event'}` : undefined}
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: { xs: 2.5, sm: 5 },
                width: '100%',
                mb: 6.75,
                p: 0,
                border: 0,
                bgcolor: 'transparent',
                textAlign: 'left',
                cursor: onClick ? 'pointer' : 'default',
                '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 4 },
                '&:hover h3': onClick ? { textDecoration: 'underline' } : undefined,
            }}>
            <Box sx={{ position: 'relative', flex: '0 0 75px', width: 75, height: 76 }}>
                <Box aria-hidden="true" sx={{ position: 'absolute', width: 72, height: 72, left: 7, top: 7, borderRight: '4px solid', borderBottom: '4px solid', borderColor: 'primary.main' }} />
                <Box sx={{ position: 'relative', width: 75, height: 76, bgcolor: 'primary.main', color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography component="time" dateTime={dateTime} sx={{ color: 'inherit', fontSize: 23, fontWeight: 900, lineHeight: 1.1 }}>{day}</Typography>
                    <Typography sx={{ color: 'inherit', fontSize: 14, fontWeight: 900, lineHeight: 1.4, mt: 0.5 }}>{month}</Typography>
                </Box>
            </Box>
            <Box sx={{ minWidth: 0, pt: 0.25 }}>
                <Typography component="h3" sx={{ color: 'primary.main', fontSize: 18, fontWeight: 700, lineHeight: 1.3, mb: 0.25 }}>{event.description || 'Untitled event'}</Typography>
                {event.venue && <Typography sx={{ color: '#252d38', fontSize: 15.5, lineHeight: 1.35 }}>{event.venue}</Typography>}
            </Box>
        </Box>
    );
}
